import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { ConsentStatus } from './useConsentStatus';

interface ConsentAcceptItem {
	policyVersionId: string;
	accepted: boolean;
}

interface AcceptConsentsPayload {
	consents: ConsentAcceptItem[];
}

export const useAcceptConsents = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (payload: AcceptConsentsPayload) => {
			try {
				const { data } = await api.post<ConsentStatus>('/consent/accept-required', payload);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao registrar aceite dos termos');
			}
		},
		onSuccess: (data) => {
			queryClient.setQueryData(['consent', 'status'], data);
		},
	});
};
